import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { UserInterface } from 'app/core/user/models';
import { sortUsersByFirstName } from 'app/shared/utilities/object-sort-methods.utility';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'cz-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss'],
})
export class UserSelectComponent implements OnInit {
  @Input()
  set users(value: UserInterface[]) {
    this._users = sortUsersByFirstName(value);
    this.filteredUserOptions = this.buildUserArrayFilter(this.filterControl, this._users);
    this.filterControl.reset();
  }
  get users(): UserInterface[] {
    return this._users;
  }
  @Input() public label: string;
  @Input() public value: UserInterface;

  @Output() public onSelect: EventEmitter<UserInterface> = new EventEmitter();

  public filterControl: FormControl = new FormControl('', Validators.required);

  public filteredUserOptions: Observable<UserInterface[]>;

  private _users: UserInterface[];
  constructor() { }

  public ngOnInit(): void {
    this.filteredUserOptions = this.buildUserArrayFilter(this.filterControl, this.users);
  }

  public autocompleteUserOption(user?: UserInterface): string | undefined {
    if(user) {
      return `${user.firstName} ${user.lastName}`;
    }

    return undefined;
  }

  public userSelected(event: MatAutocompleteSelectedEvent): void {
    this.onSelect.emit(event.option.value);
  }

  private buildUserArrayFilter(formControl: AbstractControl, userArray: UserInterface[]): Observable<UserInterface[]> {
    return formControl.valueChanges
    .pipe(
      startWith<string | UserInterface>(''),
      map((value: string | UserInterface) => {
        if (!value) { return ''; }

        return typeof value === 'string' ? value : `${value.firstName} ${value.lastName}`;
      }),
      map((name: string) => name ? this.filterUserOptions(name, userArray) : [...userArray]),
    );
  }

  private filterUserOptions(name: string, users:  UserInterface[]): UserInterface[] {
    const filterValue: string = name.toLowerCase();

    return users.filter((option: UserInterface) => {
      const fullName: string = `${option.firstName} ${option.lastName} ${option.userName}`;
      return fullName.toLowerCase().includes(filterValue);
    });
  }
}
